import { Injectable } from '@angular/core';
import {NavigationCancel, Router} from "@angular/router";
import {tap} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {ApiService} from "../../../core/services/api/api.service";
import {Api} from "../../../core/api/api";
import {HelperService} from "../../../core/services/helper/helper.service";
import {HeaderService} from "../../../core/services/header/header.service";

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(
      private _httpClient: HttpClient,
      private _router: Router,
      private _apiService: ApiService,
      private _api: Api,
      private _helper: HelperService,
      private _header: HeaderService
  ) { }

  getData(isPartner: any, data?: any) {
      return this._apiService.post(isPartner ? this._api.API.ADMIN_DASHBOARD.PARTNER_DASHBOARD_LIST :this._api.API.ADMIN_DASHBOARD.DASHBOARD_LIST, isPartner ? data : null)
  }

  stripeConfigure() {
      return this._apiService.post(this._api.API.ADMIN_DASHBOARD.PARTNER_STRIPE_URL,{})
  }
}
